module.exports = __webpack_public_path__ + "assets/img/btn-download-xbox-5897cea9.png";